import { JsonSchema } from '@jsonforms/core';

import { Dict } from '@plugins/shared/types';
import { customProfilePrefix } from '@plugins/userdetails-lib/constants';

export function autofillProfileFields(schema: JsonSchema, user: Dict) {
  if (!Object.prototype.hasOwnProperty.call(schema, 'properties')) {
    return {};
  }
  return Object.entries(schema.properties).reduce<Dict>((acc, [key, val]) => {
    if (Object.prototype.hasOwnProperty.call(val, 'properties')) {
      acc[key] = autofillProfileFields(val as JsonSchema, user);
    } else if (Object.prototype.hasOwnProperty.call(user, key)) {
      acc[key] = user[key];
    }
    return acc;
  }, {});
}

export function stripCustomPropertyPrefix(property: string) {
  if (property.startsWith(customProfilePrefix)) {
    return property.slice(customProfilePrefix.length);
  }
  return property;
}
